import React from 'react';
import { connect } from "react-redux";
import {Grid} from "semantic-ui-react";
import Header from "../../common/components/Header";
import TestcacheTable from "./TestcacheTable";
import {InlineLoading} from "../../common/partials/Loading";
import TestcacheSidebarFilters from "./TestcacheSidebarFilters";
import {fetchTestcacheTableData, unmountTestcache} from "../actions/TestcacheActions";
import Breadcrumb from '../../common/partials/Breadcrumb';
import { setBreadCrumb } from '../../veritas/breadcrumb/BreadcrumbActions';
import Sidebar from "../../common/components/Sidebar";
import SupportSidebarButtons from "../shared/SupportSidebarButtons";

export class TestCacheListPage extends React.Component {

    componentDidMount() {
        this.props.getTestcacheData();
        document.title = `Support - Testcache`;


        this.props.setBreadCrumb({
            parent: { url: '/support', text: 'Support' },
            list: { url: '/support/testcache', text: 'Test Cache' },
            service: { url: '', text: '' },
            source: { url: '', text: '' }
        })
    }

    componentWillUnmount() {
        this.props.unmountTestcache();
    }

    render() {
        return (
            <div className="support">
                <Header />
                <Grid relaxed={true}>
                    <Grid.Column width={3}>
                        <Sidebar>
                            <SupportSidebarButtons />
                            <div className="divider-background">
                                <hr />
                            </div>
                            <TestcacheSidebarFilters />
                        </Sidebar>
                    </Grid.Column>
                    <Grid.Column width={13}>
                        <Breadcrumb />
                        {this.props.testcache_filtered_state
                            ? (<TestcacheTable TestcacheData={this.props.filtered_testcache_records} />)
                            : (<InlineLoading />) }
                    </Grid.Column>
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    TestcacheData: state.support.testcache.TestcacheData,
    testcache_filtered_state: state.support.testcache.testcache_filtered_state,
    filtered_testcache_records: state.support.testcache.filtered_testcache_records,
});

const mapDispatchToProps = dispatch => ({
    getTestcacheData: () => {dispatch(fetchTestcacheTableData())},
    unmountTestcache: () => {dispatch(unmountTestcache())},
    setBreadCrumb: (crumb) => { dispatch(setBreadCrumb(crumb)) },
});


export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(TestCacheListPage)
